import React,{useState,useEffect,useCallback} from 'react'
import { useAuthAxios } from './authfetch'
import { apiurl, staticurl } from '../common/constants'
import { useNavigate } from 'react-router-dom'
import Alert from './Alert'
import UploadProgressBar from './subcomponents/UploadProgressBar'
import {BrandSelect,CategoryWithSubCategorySelect} from "./subcomponents/Selectors"
import { useStore } from '../context/StoreContext'
import AddProduct from './admin/AddProduct'
import AddBrand from './admin/AddBrand'
import AddCategory from './admin/AddCategory'
import { useAuth } from '@clerk/clerk-react'
import ImageCropper from './ImageCropper'
import './ImageCropper.css'






// main componet of adminpanel
export default function AdminManagement() {
  const navigate = useNavigate()
  // state variables
  const {brands,categories,setToast} = useStore();
  const [uploadProgress,setUploadProgess] = useState(0)
  const [updates,setUpdates] = useState({"brandUpdates":0,"categoryUpdates":0})
  const [brandAlert, setBrandAlert] = useState(null)







  

  return (
    <>
    <div className='container mt-3'>
    <div className="accordion" id="accordionExample">
      {/* prod add accordian start */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
        Add Product
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <AddProduct />
      </div>
    </div>
  </div>
  {/* prod add accordian end */}

  {/* brand add acc start */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Add Brand
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <AddBrand updates={updates} setUpdates={setUpdates} />
      </div>
    </div>
  </div>

  {/* brand add acc end */}

          {/* category add accordian start */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        Add Category
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <AddCategory updates={updates} setUpdates={setUpdates} />
      </div>
    </div>
  </div>
  {/* category add accoridan end */}



        {/* home notice start */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        Home Notice
      </button>
    </h2>
    <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">      
        <Notice uploadProgress={uploadProgress} setUploadProgess={setUploadProgess}/>
      </div>
    </div>
  </div>
  {/* home notice ends */}

  {/* Add Slider Image component */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
        Slider Images
      </button>
    </h2>
    <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">      
        <Slider uploadProgress={uploadProgress} setUploadProgess={setUploadProgess}/>
      </div>
    </div>
  </div>

  {/* General Settings Accordion */}
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSettings" aria-expanded="false" aria-controls="collapseSettings">
        General Settings
      </button>
    </h2>
    <div id="collapseSettings" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <GeneralSettings />
      </div>
    </div>
  </div>
  {/* General Settings Accordion End */}

</div>

    </div>
    
    </>
  )
}



// notice react comonent
function Notice(props){
  // increase refresh by 1 or something to refresh 
  const [refresh,setRefresh] = useState(0)
  const [noticeAlert, setNoticeAlert] = useState(null)
  const authAxios = useAuthAxios();
  const { getToken } = useAuth();
  
  useEffect(()=>{
    const fetchNotice = async () => {
      try {
        const { data } = await authAxios.get(apiurl + "/notice");
        if (data.show_image){
          document.querySelector(".show_notice_checkbox").checked = data.show_image
        }
      } catch (err) {
        console.log(err)
      }
    };
    fetchNotice();
  },[refresh])

  const handleNoticeUpdate = async (e) => {
    e.preventDefault()
    const form = document.querySelector("#noticeForm")
    const image = document.querySelector("#noticeImage").files[0]
    const show_image_bool = document.querySelector(".show_notice_checkbox")
    const show_image = show_image_bool.checked ? "true" : "false"

    const formData = new FormData()
    formData.append("noticeImage",image)
    formData.append("show_image",show_image)
    
    document.querySelector("#progressUpdateNotice").style.display = "";

    try {
      const token = await getToken();
      const { data } = await authAxios.post(apiurl + "/notice", formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
        onUploadProgress: (event) => {
          const percent = (event.loaded / event.total);
          props.setUploadProgess(percent.toFixed(2));
        }
      });
      console.log(data)
      setRefresh(refresh + 1)
      setNoticeAlert({ message: data.message, type: "success" })
      document.querySelector("#progressUpdateNotice").style.display = "none";
      form.reset()
    } catch (err) {
      console.log("error occured: ", err)
      setNoticeAlert({ message: "An error occurred", type: "danger" })
    }
  }
  return (
    <>
    {noticeAlert && <div className="mb-3"><Alert message={noticeAlert.message} type={noticeAlert.type} /></div>}
    <form id="noticeForm">
      <span>Select Notice Image</span>
      <div className="my-3">
        <input className="form-control noticeImage" type="file" id="noticeImage" required/>
      </div>
      <div className="form-check form-switch">
        <input className="form-check-input show_notice_checkbox" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{border: "2px solid #4c4747"}} />
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Show Notice</label>
      </div>
      <UploadProgressBar uploadProgressValue={props.uploadProgress} progressBarId="progressUpdateNotice" />
      <button className='btn btn-primary' onClick={(e)=>handleNoticeUpdate(e)}>Update Notice</button>

    </form>
    </>
  )
}


// add Slider Image Component
function Slider(props){
  const authAxios = useAuthAxios();
  const { getToken } = useAuth();
  
  // State for processed images (after cropping/padding)
  const [processedImages, setProcessedImages] = useState({
    image1: null,
    image2: null,
    image3: null
  });
  
  // State for image previews
  const [imagePreviews, setImagePreviews] = useState({
    image1: null,
    image2: null,
    image3: null
  });
  
  // State for cropper modal
  const [cropperState, setCropperState] = useState({
    isOpen: false,
    imageSrc: null,
    imageNumber: null,
    originalFileName: ''
  });

  // Handle file selection - opens cropper
  const handleFileSelect = useCallback((e, imageNumber) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = () => {
      setCropperState({
        isOpen: true,
        imageSrc: reader.result,
        imageNumber: imageNumber,
        originalFileName: file.name
      });
    };
    reader.readAsDataURL(file);
  }, []);

  // Handle crop complete
  const handleCropComplete = useCallback((processedFile, imageNumber) => {
    const imageKey = `image${imageNumber}`;
    
    // Store the processed file
    setProcessedImages(prev => ({
      ...prev,
      [imageKey]: processedFile
    }));
    
    // Create preview URL
    const previewUrl = URL.createObjectURL(processedFile);
    setImagePreviews(prev => ({
      ...prev,
      [imageKey]: previewUrl
    }));
    
    // Close cropper
    setCropperState({
      isOpen: false,
      imageSrc: null,
      imageNumber: null,
      originalFileName: ''
    });
    
    // Clear the file input
    const inputElement = document.querySelector(`#sliderimage${imageNumber}`);
    if (inputElement) {
      inputElement.value = '';
    }
  }, []);

  // Handle cropper cancel
  const handleCropCancel = useCallback(() => {
    setCropperState({
      isOpen: false,
      imageSrc: null,
      imageNumber: null,
      originalFileName: ''
    });
    
    // Clear the file input
    if (cropperState.imageNumber) {
      const inputElement = document.querySelector(`#sliderimage${cropperState.imageNumber}`);
      if (inputElement) {
        inputElement.value = '';
      }
    }
  }, [cropperState.imageNumber]);

  // Remove a processed image
  const handleRemoveImage = useCallback((imageNumber) => {
    const imageKey = `image${imageNumber}`;
    
    // Revoke the preview URL to free memory
    if (imagePreviews[imageKey]) {
      URL.revokeObjectURL(imagePreviews[imageKey]);
    }
    
    setProcessedImages(prev => ({
      ...prev,
      [imageKey]: null
    }));
    setImagePreviews(prev => ({
      ...prev,
      [imageKey]: null
    }));
  }, [imagePreviews]);

  // Re-crop an existing image
  const handleRecrop = useCallback((imageNumber) => {
    const imageKey = `image${imageNumber}`;
    const processedFile = processedImages[imageKey];
    
    if (processedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        setCropperState({
          isOpen: true,
          imageSrc: reader.result,
          imageNumber: imageNumber,
          originalFileName: processedFile.name
        });
      };
      reader.readAsDataURL(processedFile);
    }
  }, [processedImages]);

  const handleSliderImageUpload = async (e) => {
    e.preventDefault();
    const form = document.querySelector("#sliderForm")
    const img1 = processedImages.image1;
    const img2 = processedImages.image2;
    const img3 = processedImages.image3;

    if (!img1 && !img2 && !img3){
      alert("No Image Selected to continue. Please select and crop/process images first.")
      return
    }

    let imgnames=[];

    const formData = new FormData()
    if (img1){
      formData.append("sliderImages", img1)
      imgnames.push(["image1", img1.name, document.querySelector("#link1").value])
    }
    if(img2){
      formData.append("sliderImages", img2)
      imgnames.push(["image2", img2.name, document.querySelector("#link2").value])
    }
    if(img3){
      formData.append("sliderImages", img3)
      imgnames.push(["image3", img3.name, document.querySelector("#link3").value])
    }
    formData.append("imgnames", JSON.stringify(imgnames))
    
    document.querySelector("#progressSliderUpload").style.display = "";

    try {
      const token = await getToken();
      const { data } = await authAxios.post(apiurl + "/sliderimages", formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
        onUploadProgress: (event) => {
          const percent = (event.loaded / event.total);
          props.setUploadProgess(percent.toFixed(2));
        }
      });
      console.log(data);
      alert(data.message);
      document.querySelector("#progressSliderUpload").style.display = "none";
      form.reset();
      
      // Clear processed images and previews
      Object.values(imagePreviews).forEach(url => {
        if (url) URL.revokeObjectURL(url);
      });
      setProcessedImages({ image1: null, image2: null, image3: null });
      setImagePreviews({ image1: null, image2: null, image3: null });
    } catch (err) {
      console.log("error occurred: ", err);
    }
  }

  // Render image input with preview
  const renderImageInput = (imageNumber) => {
    const imageKey = `image${imageNumber}`;
    const preview = imagePreviews[imageKey];
    const processed = processedImages[imageKey];
    
    return (
      <div className="slider-image-input-container">
        <label htmlFor={`sliderimage${imageNumber}`} className="form-label">
          Image {imageNumber}
          <small className="text-muted ms-2">(Will be cropped/resized to 1920×720)</small>
        </label>
        <input 
          className="form-control" 
          type="file" 
          accept='image/*' 
          id={`sliderimage${imageNumber}`}
          onChange={(e) => handleFileSelect(e, imageNumber)}
        />
        
        {preview && (
          <div className="slider-image-preview">
            <img src={preview} alt={`Preview ${imageNumber}`} />
            <div className="slider-image-preview-info">
              <strong>{processed?.name}</strong>
              <br />
              <span className={`processed-badge ${processed?.name?.includes('_cropped') ? 'cropped' : 'padded'}`}>
                {processed?.name?.includes('_cropped') ? '✂️ Cropped' : '📐 Auto-Padded'}
              </span>
            </div>
            <div className="slider-image-preview-actions">
              <button 
                type="button"
                className="btn btn-sm btn-outline-secondary btn-edit-crop"
                onClick={() => handleRecrop(imageNumber)}
              >
                Re-crop
              </button>
              <button 
                type="button"
                className="btn btn-sm btn-remove-image"
                onClick={() => handleRemoveImage(imageNumber)}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='image_uploader'>
      {/* Image Cropper Modal */}
      {cropperState.isOpen && (
        <ImageCropper
          imageSrc={cropperState.imageSrc}
          imageNumber={cropperState.imageNumber}
          originalFileName={cropperState.originalFileName}
          onCropComplete={handleCropComplete}
          onCancel={handleCropCancel}
        />
      )}
      
      <form id="sliderForm">
        <div className='note'>
          Note: <strong>LinkTo</strong> will redirect to the given url. Leave <strong>LinkTo</strong> blank if you just want to display images.
          <br />
          <strong>Images will be cropped/resized to 1920×720 pixels for optimal display.</strong>
        </div>
        
        <div className="mb-3">
          {renderImageInput(1)}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" id="linkto1">LinkTo</span>
          <input type="text" className="form-control" placeholder="page Url" aria-label="Username" aria-describedby="linkto1" id="link1"/>
        </div>

        <hr />
        <div className="mb-3">
          {renderImageInput(2)}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" id="linkto2">LinkTo</span>
          <input type="text" className="form-control" placeholder="page Url" aria-label="Username" aria-describedby="linkto2" id="link2" />
        </div>
        <hr />

        <div className="mb-3">
          {renderImageInput(3)}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" id="linkto3">LinkTo</span>
          <input type="text" className="form-control" placeholder="page Url" aria-label="Username" id="link3" aria-describedby="linkto3" />
        </div>
        <hr />
        <UploadProgressBar uploadProgressValue={props.uploadProgress} progressBarId="progressSliderUpload" />

        <button className='btn btn-primary' onClick={(e)=>handleSliderImageUpload(e)}>Add Slider Images</button>
      </form>
    </div>
  )
}


function GeneralSettings() {
    const { isOrderingEnabled, setIsOrderingEnabled, fetchOrderingStatus, setToast } = useStore();
    const authAxios = useAuthAxios();
    
    // Tawk.to settings state
    const [tawkConfig, setTawkConfig] = useState({
        propertyId: '',
        widgetId: '',
        enabled: true
    });
    const [tawkLoading, setTawkLoading] = useState(true);

    // Fetch Tawk.to settings on mount
    useEffect(() => {
        const fetchTawkSettings = async () => {
            try {
                const { data } = await authAxios.get(`${apiurl}/settings/tawkto`);
                if (data?.data?.value) {
                    setTawkConfig({
                        propertyId: data.data.value.propertyId || '',
                        widgetId: data.data.value.widgetId || '',
                        enabled: data.data.value.enabled !== false
                    });
                }
            } catch (error) {
                console.error('Failed to fetch Tawk.to settings:', error);
            } finally {
                setTawkLoading(false);
            }
        };
        fetchTawkSettings();
    }, [authAxios]);

    const handleToggle = async (e) => {
        const newValue = e.target.checked;
        try {
            const { data, status } = await authAxios.post(apiurl + "/settings", {
                key: "ordering_enabled",
                value: newValue
            });
            
            if (status >= 200 && status < 300) {
                setIsOrderingEnabled(newValue);
                setToast({show:true, message: data.message || "Setting updated", type: "success" });
                setTimeout(() => setToast(false), 3000);
            } else {
                setToast({show:true, message: data.message || "Update failed", type: "error" });
                setTimeout(() => setToast(false), 3000);
                fetchOrderingStatus(); 
            }
        } catch (error) {
            console.error("Failed to update setting:", error);
            setToast({ message: "Failed to update setting", type: "error" });
            fetchOrderingStatus();
        }
    };

    const handleTawkSave = async () => {
        if (!tawkConfig.propertyId || !tawkConfig.widgetId) {
            setToast({ show: true, message: "Property ID and Widget ID are required", type: "error" });
            setTimeout(() => setToast(false), 3000);
            return;
        }

        try {
            const { data, status } = await authAxios.post(`${apiurl}/settings`, {
                key: "tawkto",
                value: {
                    propertyId: tawkConfig.propertyId,
                    widgetId: tawkConfig.widgetId,
                    enabled: tawkConfig.enabled
                }
            });

            if (status >= 200 && status < 300) {
                setToast({ show: true, message: "Tawk.to settings updated. Refresh page to apply.", type: "success" });
                setTimeout(() => setToast(false), 3000);
            } else {
                setToast({ show: true, message: data.message || "Update failed", type: "error" });
                setTimeout(() => setToast(false), 3000);
            }
        } catch (error) {
            console.error("Failed to update Tawk.to settings:", error);
            setToast({ show: true, message: "Failed to update Tawk.to settings", type: "error" });
            setTimeout(() => setToast(false), 3000);
        }
    };

    return (
        <div className="p-2">
            <h5>Store Controls</h5>
            <div className="form-check form-switch mt-3">
                <input 
                    className="form-check-input" 
                    type="checkbox" 
                    role="switch" 
                    id="orderingToggle" 
                    checked={isOrderingEnabled}
                    onChange={handleToggle}
                    style={{ cursor: "pointer", width: "3em", height: "1.5em" }}
                />
                <label className="form-check-label ms-2 pt-1" htmlFor="orderingToggle">
                    Enable Ordering Functionality (Show "Order Now" buttons)
                </label>
            </div>

            <hr className="my-4" />

            <h5>Tawk.to Live Chat</h5>
            <p className="text-muted small">Configure your Tawk.to chat widget. Get these values from your Tawk.to dashboard.</p>
            
            {tawkLoading ? (
                <div className="text-muted">Loading settings...</div>
            ) : (
                <>
                    <div className="mb-3">
                        <label htmlFor="tawkPropertyId" className="form-label">Property ID</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            id="tawkPropertyId"
                            placeholder="e.g., 6968cff40f26dd197d6594f8"
                            value={tawkConfig.propertyId}
                            onChange={(e) => setTawkConfig({ ...tawkConfig, propertyId: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="tawkWidgetId" className="form-label">Widget ID</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            id="tawkWidgetId"
                            placeholder="e.g., 1jf0molt8"
                            value={tawkConfig.widgetId}
                            onChange={(e) => setTawkConfig({ ...tawkConfig, widgetId: e.target.value })}
                        />
                    </div>
                    <div className="form-check form-switch mb-3">
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            role="switch" 
                            id="tawkEnabledToggle" 
                            checked={tawkConfig.enabled}
                            onChange={(e) => setTawkConfig({ ...tawkConfig, enabled: e.target.checked })}
                            style={{ cursor: "pointer", width: "3em", height: "1.5em" }}
                        />
                        <label className="form-check-label ms-2 pt-1" htmlFor="tawkEnabledToggle">
                            Enable Live Chat Widget
                        </label>
                    </div>
                    <button className="btn btn-primary" onClick={handleTawkSave}>
                        Save Tawk.to Settings
                    </button>
                </>
            )}
        </div>
    );
}